// Single source of truth for PFG (Warranty) source badge colors. Mirrors the
// source enum in Warranty: who submitted the PFG request.
//
// These are the colors the PFG show page has always used; the table was brought
// into line with the show page rather than the other way around.
const WARRANTY_SOURCE_COLORS = {
  admin: 'green',
  partner: 'orange',
  user: 'blue',
};

// Accepts either the raw enum value or the humanized/capitalized form the AG
// Grid columns display. Returns null for anything that is not a warranty source
// so callers can fall back to their own default.
function warrantySourceColor(source) {
  if (!source) {
    return null;
  }

  const key = String(source).toLowerCase().replace(/\s+/g, '_');

  return WARRANTY_SOURCE_COLORS[key] || null;
}

export default warrantySourceColor;
